// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import NavbarController from "./navbar_controller"
application.register("navbar", NavbarController)

import DropdownController from "./dropdown_controller"
application.register("dropdown", DropdownController)

import CarouselController from "./carousel_controller"
application.register("carousel", CarouselController)

import ArticlePopupController from "./article_popup_controller"
application.register("article-popup", ArticlePopupController)
